import { useEffect, useState } from 'react';
import { dataClient } from '../data/dataClient';

export function useWorkspace() {
  const [workspace, setWorkspace] = useState(dataClient.peek());

  useEffect(() => dataClient.subscribe(setWorkspace), []);

  return workspace;
}